import React, { lazy } from 'react';

import i18n from '@/i18n';
import AppLayout from '@/layout/AppLayout';
import LeftNavLayout from '@/layout/LeftNavLayout';
import { lazyNamedImport } from '@/utils/lazyNamedImport';

import ErrorBoundary from '../ErrorBoundary';

const Password = lazy(() => import('@/pages/personal/password'));
const Auth = lazy(() => import('@/pages/personal/view-auth'));
const BenefitsCenterPage = lazyNamedImport(() => import('@/pages/personal/benefits-center'), 'BenefitsCenterPage');
const t = i18n.t.bind(i18n);

export const personalRouters = {
  path: '/',
  element: <AppLayout />,
  title: t('common:personal.center'),
  children: [
    {
      element: <LeftNavLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        {
          title: 'personalBenefitsCenter',
          path: '/personal/benefits-center',
          element: <BenefitsCenterPage />,
        },
        {
          path: '/personal/password',
          element: <Password />,
        },
        {
          path: '/personal/auth',
          element: <Auth />,
        },
      ],
    },
  ],
};
